// components/auto-export-poezd/datetimepicker

// общие настройки
var settings = ({
  lang: 'ru',
  timepicker: true,
  format: 'd-m-Y H:i',

})
// навешиваем события на инпуты datetimepicker
// http://xdsoft.net/jqplugins/datetimepicker/
export default function ({'input-date': date}) {
    var $date = $('.' + date)
    if( !$date ) return;

  $date.datetimepicker($.extend(settings, {
    onShow: function(ct) {
        var start = $date.val().replace(/-/g,'/')
        this.setOptions({
            //minDate: start ? start : 0,
     })
    }
  }))
}



/** WEBPACK FOOTER **
 ** ./src/js/components/auto-export-poezd/datetimepicker.js
 **/